import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'

import Heading from '~/client/components/Heading'

export default function PrivacyPage() {
  return <Container>
    <Paper sx={{p: 2, m: 2, maxWidth: 'sm', mx: 'auto'}} >
      <Heading variant="main">Privacy</Heading>
      <p>
        The DataPal team cannot see your data, nor can anyone
        who does not have access to your cryptographic key
        which unlocks your data storage when you need it.
      </p>
      <p>
        Any data visibility or sharing with applications or
        organisations is entirely under your control.
      </p>
      <p>
        Meta data (data about data) is shared with the DataPal
        team and organisation in order that we can run the
        operational service. Minimum data is gathered for this
        purpose; the details of this are in our terms and
        conditions document linked here (link to be built).
      </p>
    </Paper>
  </Container>
}
